import z from 'zod';

import type {
  TransactionRulePreviewResponse,
  TransactionRuleType,
} from 'app-components/flux/transaction-rules/transactionRulesTypes';
import { RemoteTransactionRuleSchema } from 'app-components/flux/transaction-rules/transactionRulesTypes';
import {
  transformClientDataToQCSResponse,
  transformQCSResponseToClientData,
} from 'app-components/flux/transaction-rules/transactionRulesUtils';
import { httpClientInterface } from 'app-components/utils/core';
import { getServiceUrl } from 'app-components/utils/core/interfaces/httpClientInterface';

const GetTransactionRulesResponseSchema = z.object({
  resources: z.array(RemoteTransactionRuleSchema),
});

const PostTransactionRulesResponseSchema = z.object({
  resource: RemoteTransactionRuleSchema,
  clientId: z.string().optional(),
  id: z.string(),
});

const PutTransactionRulesResponseSchema = z.object({
  resource: RemoteTransactionRuleSchema,
  id: z.string(),
});

export default {
  async fetch() {
    const requestUrl = `${getServiceUrl()}/transaction-rules?limit=5000`;
    const qcsResponse = await httpClientInterface.send('GET', requestUrl);
    const response = GetTransactionRulesResponseSchema.parse(qcsResponse.data);
    const transformed = transformQCSResponseToClientData(response.resources);
    return transformed;
  },
  async fetchPreview(resource: TransactionRuleType & { clientId: string }) {
    const requestUrl = `${getServiceUrl()}/categories-aggregation/preview/txn-rule`;
    const payload = transformClientDataToQCSResponse(resource);
    const qcsResponse = await httpClientInterface.send('POST', requestUrl, payload);
    return qcsResponse as TransactionRulePreviewResponse;
  },
  async create(item: TransactionRuleType & { clientId: string }) {
    const requestUrl = `${getServiceUrl()}/transaction-rules`;
    const payload = transformClientDataToQCSResponse(item);
    const qcsResponse = await httpClientInterface.send('POST', requestUrl, payload);
    const response = PostTransactionRulesResponseSchema.parse(qcsResponse.data);
    const transformed = transformQCSResponseToClientData([response.resource]);
    return { ...response, resource: transformed[0] };
  },
  async update(item: TransactionRuleType & { id: string }) {
    const requestUrl = `${getServiceUrl()}/transaction-rules/${item.id}`;
    const payload = transformClientDataToQCSResponse(item);
    const qcsResponse = await httpClientInterface.send('PUT', requestUrl, payload);
    const response = PutTransactionRulesResponseSchema.parse(qcsResponse.data);
    const transformed = transformQCSResponseToClientData([response.resource]);
    return { ...response, resource: transformed[0] };
  },
  async delete(id: string) {
    const requestUrl = `${getServiceUrl()}/transaction-rules/${id}`;
    const qcsResponse = await httpClientInterface.send('DELETE', requestUrl);
    return qcsResponse;
  },
} as const;
